import React, { useContext } from 'react';
import { CircularProgress, Grid, TextField } from '@material-ui/core';
import { FormServiceContext } from 'app/utils/contexts';
import ScheduleTableBoard from '../../../ScheduleTableBoard/ScheduleTableBoard';
import { Field, useFormikContext } from 'formik';

const ScheduleTab = (props) => {
    const { classes, loading, isStripContext } = props;
    const { canEdit } = useContext(FormServiceContext);
    const { errors, touched } = useFormikContext();

    if (loading) {
        return (
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <div className={classes.centerProgress}>
                        <CircularProgress size={20} />
                    </div>
                </Grid>
            </Grid>
        );
    }

    return (
        <>
            <Grid item xs={12} container alignItems="flex-start">
                {loading && (
                    <Grid item xs={12} style={{ textAlign: 'center' }}>
                        <CircularProgress size={12} />
                    </Grid>
                )}
                {!loading && <ScheduleTableBoard {...props} readOnly={!canEdit} />}
            </Grid>
            {isStripContext && (
                <Grid item xs={12}>
                    <Field
                        name="deObservacao"
                        label="Observação"
                        variant="filled"
                        margin="dense"
                        disabled={!canEdit}
                        error={!!errors.deObservacao && touched.deObservacao}
                        helperText={errors.deObservacao && touched.deObservacao ? errors.deObservacao : ''}
                        multiline
                        minRows={4}
                        fullWidth
                        as={TextField}
                        inputProps={{
                            maxLength: 5000,
                        }}
                    />
                </Grid>
            )}
        </>
    );
};

export default ScheduleTab;
